import { Typography, TypographyProps } from "@mui/material";

export interface CustomTypographyProps extends TypographyProps {}

export const CustomTypography = ({
  children,
  sx,
  ...props
}: CustomTypographyProps) => {
  const baseSx = { fontFamily: "Red Hat Display" } as const;
  const extraSx = Array.isArray(sx) ? sx : sx ? [sx] : [];
  return (
    <Typography {...props} sx={[baseSx, ...extraSx]}>
      {children}
    </Typography>
  );
};
